import dayjs from "dayjs";
import { api } from "@service/api";

import { ZuToastifyStore } from "@hooks/stores/zustand-toastify-store";

import { Card } from "@components/cards/card";
import Skeleton from "react-loading-skeleton";
import { useEffect, useState } from "react";
import { RaffleStatusTypes } from "@hooks/dtos/raffles/IRaffleGeneralDTO";
import {
  getRaffleStatus,
  raffleStatusSelect,
} from "@hooks/functions/Raffle/status";
import { FaBroom, FaExpand, FaEye, FaMinus } from "react-icons/fa6";
import { Masks } from "@hooks/functions/Masks/Masks";
import { Pagination } from "@components/pagination";
import { Input } from "@components/forms/input";
import { Select } from "@components/forms/select";
import {
  getRaffleDefaultTicketTransactionStatus,
  raffleDefaultTicketTransactionSelect,
} from "@hooks/functions/Order/status";
import { RaffleDefaultTicketTransactionStatusTypes } from "@hooks/enums/raffle_default_ticket_transactions";
import { IRaffleDefaultTicketTransactionListDTO } from "@hooks/dtos/raffles/IRaffleDefaultTicketTransactionDTO";
import { Link } from "react-router-dom";
import { ModalTicketOrderInfo } from "@components/modals/modal-raffle-affiliate-summary";
import { FiRefreshCcw } from "react-icons/fi";

interface IFilters {
  status: RaffleDefaultTicketTransactionStatusTypes | undefined;
  raffleStatus: RaffleStatusTypes | undefined;
}

const masks = new Masks();
export function MyAcquisitionsTab() {
  // Plugins & Functions
  const {
    actions: { pushToastify },
  } = ZuToastifyStore();

  // Control Things & General Configs
  const [isLoading, setIsLoading] = useState<{ orders: boolean }>({
    orders: true,
  });
  const [orders, setOrders] = useState<
    IRaffleDefaultTicketTransactionListDTO[]
  >([]);

  // Pagination Part
  const [take] = useState(10);
  const [page, setPage] = useState(1);
  const [order, setOrder] = useState("DESC");
  const [total, setTotal] = useState(0);
  const [totalPages, setTotalPages] = useState(1);

  // --- Another Control --- //
  const [show, setShow] = useState<{ filter: boolean }>({
    filter: false,
  });
  const [selectedOrderId, setSelectedOrderId] = useState<number>();

  // --- Filters --- //
  const [startAt, setStartAt] = useState("");
  const [endAt, setEndAt] = useState("");
  const [filters, setFilters] = useState<IFilters>({
    status: undefined,
    raffleStatus: undefined,
  });
  const [searchRaffle, setSearchRaffle] = useState<string | undefined>();

  async function handleOrderList() {
    setIsLoading((prev) => ({ ...prev, orders: true }));

    try {
      const params = {
        page,
        take,
        order,
        paymentStatus: filters.status || undefined,
        raffleStatus: filters.raffleStatus || undefined,
        searchRaffle: searchRaffle || undefined,
        startDate: startAt || undefined,
        endDate: endAt || undefined,
      };
      const result = await api.get(`/raffleClient/default/order/list`, {
        params,
      });

      setTotal(result.data.total);
      setOrders(result.data.list);
      setTotalPages(Number(result.data.totalPages) || 1);
    } catch (err: any) {
      pushToastify({
        message: err?.response?.data.message ?? "",
        type: "error",
        theme: "dark",
      });
    } finally {
      setIsLoading((prev) => ({ ...prev, orders: false }));
    }
  }

  function applyFilters() {
    setPage(1);
  }

  function cleanFilters() {
    setFilters({
      status: undefined,
      raffleStatus: undefined,
    });
    setSearchRaffle(undefined);
    setStartAt("");
    setEndAt("");
    setPage(1);
  }

  useEffect(() => {
    handleOrderList();
    // Keep filter submission explicit through the filter and refresh actions.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, order]);

  return (
    <>
      {/* Filters */}
      <div className="row">
            <div className="col-md-12">
              <Card>
                <button
                  type="button"
                  className="card-header border-0 text-start w-100"
                  onClick={() => {
                    setShow((prev) => ({
                      ...prev,
                      filter: !show.filter,
                    }));
                  }}
                >
                  <div className="d-flex justify-content-between">
                    <div className="">
                      <div className="card-title">Filtrar Aquisição</div>
                      <div className="card-category">
                        Utilize o filtro para consultar um período específico.
                      </div>
                    </div>
                    <div className="">
                      {show.filter ? (
                        <FaMinus
                          className="fs-5"
                          title="Clique para ocultar as informações."
                        />
                      ) : (
                        <FaExpand
                          className="fs-5"
                          title="Clique para visualizar as informações."
                        />
                      )}
                    </div>
                  </div>
                </button>
                <div className={`card-body ${show.filter ? `` : `d-none`}`}>
                  <div className="row g-3 align-items-end">
                    <div className="col-12 col-lg-6">
                      <Input
                        animated
                        label="Nome da Campanha"
                        placeholder="Digite o nome da campanha"
                        type="text"
                        value={searchRaffle || ""}
                        onChange={(e) => {
                          setSearchRaffle(e.target.value);
                        }}
                        onKeyUp={(e) => e.key === "Enter" && applyFilters()}
                      />
                    </div>
                    {/* Raffle Status */}
                    <div className="col-12 col-md-6 col-lg-3">
                      <Select
                        animated
                        label="Status da Campanha"
                        className="form-select form-control"
                        aria-label="status"
                        value={filters.raffleStatus || ""}
                        options={[
                          ...raffleStatusSelect.map((x) => ({
                            value: x.status,
                            name: x.text,
                          })),
                        ]}
                        onChange={(e) => {
                          setFilters((prev) => ({
                            ...prev,
                            raffleStatus: e.target.value as RaffleStatusTypes,
                          }));
                        }}
                      />
                    </div>
                    {/* Status */}
                    <div className="col-12 col-md-6 col-lg-3">
                      <Select
                        animated
                        label="Status da Aquisição"
                        className="form-select form-control"
                        aria-label="status"
                        value={filters.status || ""}
                        options={[
                          ...raffleDefaultTicketTransactionSelect.map((x) => ({
                            value: x.status,
                            name: x.text,
                          })),
                        ]}
                        onChange={(e) => {
                          setFilters((prev) => ({
                            ...prev,
                            status: e.target
                              .value as RaffleDefaultTicketTransactionStatusTypes,
                          }));
                        }}
                      />
                    </div>
                    {/* Dates */}
                    <div className="col-12 col-md-6 col-lg-3">
                      <Input
                        animated
                        id="startAt"
                        label="Data Inicial"
                        placeholder=""
                        type="date"
                        value={startAt}
                        onChange={(e) => setStartAt(e.target.value)}
                      />
                    </div>
                    <div className="col-12 col-md-6 col-lg-3">
                      <Input
                        animated
                        id="endAt"
                        label="Data Final"
                        placeholder=""
                        type="date"
                        value={endAt}
                        onChange={(e) => setEndAt(e.target.value)}
                      />
                    </div>
                    <div className="col-12 col-lg-6">
                      <div className="d-flex flex-column flex-sm-row justify-content-lg-end gap-2 pb-1">
                        <button
                          type="button"
                          className="btn btn-outline-secondary px-4 order-2 order-sm-1"
                          onClick={cleanFilters}
                          title="Limpar todos os filtros."
                        >
                          <FaBroom className="me-2" />
                          Limpar
                        </button>
                        <button
                          type="button"
                          className="btn btn-success px-5 order-1 order-sm-2"
                          onClick={applyFilters}
                        >
                          Filtrar
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </Card>
            </div>
          </div>

          <Card className="OrderList">
            <div className="card-header">
              <div className="row align-items-center g-3">
                <div className="col-md-8">
                  <div className="card-title">Minhas Aquisições</div>
                  <div className="card-category">
                    Acompanhe suas transações e os números adquiridos.
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="d-flex justify-content-md-end align-items-center gap-3">
                    {/* Sort order */}
                    <div className="">
                      <Select
                        animated
                        label="Ordenação"
                        className="form-select form-control"
                        aria-label="status"
                        value={order}
                        options={[
                          { value: "DESC", name: "Recentes" },
                          { value: "ASC", name: "Antigas" },
                        ]}
                        onChange={(e) => {
                          setOrder(e.target.value);
                        }}
                      />
                    </div>
                    <div className="">
                      <FiRefreshCcw
                        className="fs-4"
                        title="Atualizar aquisições."
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          handleOrderList();
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="card-body">
              {isLoading.orders ? (
                <Skeleton count={5} height={38} borderRadius={5} />
              ) : (
                <>
                  <div className="table-responsive">
                    <table className="table table-hover align-middle mb-0">
                      <thead className="table-light">
                        <tr>
                          <th scope="col" className="text-nowrap">
                            Transação
                          </th>
                          <th scope="col" className="w-25">
                            Campanha
                          </th>
                          <th scope="col" className="text-center text-nowrap">
                            Tickets
                          </th>
                          <th scope="col" className="text-nowrap">
                            Valor
                          </th>
                          <th
                            scope="col"
                            className="text-nowrap"
                            title="Status da Campanha"
                          >
                            Campanha
                          </th>
                          <th
                            scope="col"
                            className="text-nowrap"
                            title="Status da Aquisição"
                          >
                            Aquisição
                          </th>
                          <th scope="col" className="text-nowrap">
                            Data
                          </th>
                          <th scope="col" className="text-end text-nowrap">
                            Ações
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {orders.length === 0 ? (
                          <tr>
                            <td colSpan={8} className="text-center py-5">
                              <div className="fw-semibold">
                                Nenhum registro encontrado.
                              </div>
                              <small className="text-muted">
                                Ajuste os filtros para consultar outras
                                aquisições.
                              </small>
                            </td>
                          </tr>
                        ) : (
                          orders.map((transaction) => {
                            const transactionStatus =
                              getRaffleDefaultTicketTransactionStatus(
                                transaction.status,
                              );
                            const raffleStatus = transaction.raffleData?.status
                              ? getRaffleStatus(transaction.raffleData.status)
                              : undefined;

                            return (
                              <tr key={transaction.id}>
                                <td>
                                  <span className="fw-semibold">
                                    #{transaction.id}
                                  </span>
                                </td>
                                <td className="w-25">
                                  <Link
                                    to={`/campaign/default?campaign=${transaction?.raffleData?.campaign}${
                                      transaction?.raffleData?.key
                                        ? `&key=${transaction?.raffleData?.key}`
                                        : ""
                                    }`}
                                    className="text-decoration-none"
                                  >
                                    <span
                                      className="fw-semibold d-block"
                                      title={
                                        transaction.raffleData
                                          ?.description_short
                                      }
                                    >
                                      {transaction.raffleData?.name ||
                                        "Campanha não informada"}
                                    </span>
                                    <small className="text-muted">
                                      {transaction.raffleData?.campaign
                                        ?.replaceAll("-", " ")
                                        .replace(/\b\w/g, (letter) =>
                                          letter.toUpperCase(),
                                        ) || ""}
                                      {transaction.raffleData?.key
                                        ? ` • #${transaction.raffleData.key}`
                                        : ""}
                                    </small>
                                  </Link>
                                </td>
                                <td className="text-center">
                                  <span className="badge bg-outline-primary text-black">
                                    {masks.formatMilhar(
                                      transaction.ticketCount,
                                    )}{" "}
                                    ticket
                                    {transaction.ticketCount === 1 ? "" : "s"}
                                  </span>
                                </td>
                                <td className="fw-semibold text-nowrap">
                                  {masks.brlCurrency(Number(transaction.value))}
                                </td>
                                <td className="text-nowrap">
                                  {raffleStatus ? (
                                    <span
                                      className={`badge text-${raffleStatus.color}`}
                                      title={raffleStatus.title}
                                    >
                                      {raffleStatus.text}
                                    </span>
                                  ) : (
                                    "-"
                                  )}
                                </td>
                                <td className="text-nowrap">
                                  <span
                                    className={`badge bg-${transactionStatus.color}`}
                                    title={transactionStatus.title}
                                  >
                                    {transactionStatus.text}
                                  </span>
                                </td>
                                <td className="text-nowrap">
                                  {transaction.createdAt
                                    ? dayjs(transaction.createdAt).format(
                                        "DD/MM/YYYY [às] HH:mm",
                                      )
                                    : "-"}
                                  {transaction.paidAt && (
                                    <small className="d-block text-success">
                                      Pago em{" "}
                                      {dayjs(transaction.paidAt).format(
                                        "DD/MM/YYYY [às] HH:mm",
                                      )}
                                    </small>
                                  )}
                                </td>
                                <td className="text-end">
                                  <button
                                    type="button"
                                    className="btn btn-sm btn-outline-primary"
                                    title={`Ver transação #${transaction.id}`}
                                    aria-label={`Ver transação #${transaction.id}`}
                                    onClick={() =>
                                      setSelectedOrderId(transaction.id)
                                    }
                                  >
                                    <FaEye />
                                  </button>
                                </td>
                              </tr>
                            );
                          })
                        )}
                      </tbody>
                    </table>
                  </div>

                  <div className="d-flex flex-column flex-md-row gap-3 justify-content-between align-items-md-center border-top mt-3 pt-3">
                    <div>
                      <small className="text-muted">
                        Página {page} de {totalPages} página
                        {totalPages > 1 ? `s` : ``} ({masks.formatMilhar(total)}{" "}
                        registro
                        {total > 1 ? `s` : ``} encontrado{total > 1 ? `s` : ``})
                      </small>
                    </div>
                    <div>
                      <Pagination
                        page={page}
                        setPage={setPage}
                        totalPages={totalPages}
                        maxPageShow={7}
                      />
                    </div>
                  </div>
                </>
              )}
            </div>
          </Card>

      {selectedOrderId && (
        <ModalTicketOrderInfo
          orderId={selectedOrderId}
          isOpen
          onClose={() => setSelectedOrderId(undefined)}
        />
      )}
    </>
  );
}
